export enum CodeableType {
  COMPANY = 'Company',
  COMPANY_DB_FILE = 'CompanyDbFile',
  SIREN_NUMBER = 'SirenNumber',
  WORKPLACE_CODE_ENABLED = 'WorkplaceCodeEnabled',
  EMPLOYEE = 'Employee',
  CONTRACTS_COMPENSATIONS_TAXONOMY = 'ContractsCompensationsTaxonomy',
  TIMEOFF_LEAVE_TYPE = 'TimeoffLeaveType',
  LEGAL_ENTITY = 'LegalEntity',
  LOCATION = 'Location',
  BOOKKEEPER = 'Bookkeeper',
  VALID_FROM = 'ValidFrom',
}
